// extracted by mini-css-extract-plugin
module.exports = {"cellText":"LessonInformation_cellText__Xg_jU","lessonRef":"LessonInformation_lessonRef__2gBYA","lessonRefLabel":"LessonInformation_lessonRefLabel__116KW"};